<svelte:head>
	<script>
		try {
			(function (w, d, t, r, u) {
				var f, n, i;
				((w[u] = w[u] || []),
					(f = function () {
						// An ad blocker can serve a stub in place of bat.js: onload still
						// fires but UET is never defined, and this runs outside the try.
						if (typeof w.UET !== 'function') return;
						var o = { ti: '97021792' };
						((o.q = w[u]), (w[u] = new w.UET(o)), w[u].push('pageLoad'));
					}),
					(n = d.createElement(t)),
					(n.src = r),
					(n.async = 1),
					(n.onload = n.onreadystatechange =
						function () {
							var s = this.readyState;
							(s && s !== 'loaded' && s !== 'complete') ||
								(f(), (n.onload = n.onreadystatechange = null));
						}),
					(i = d.getElementsByTagName(t)[0]),
					i.parentNode.insertBefore(n, i));
			})(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
		} catch (e) {
			console.error(e);
			// Silently fail if UET script is blocked
		}
	</script>
</svelte:head>
